export const NEXT_TOKEN_1 = `Discover your most valuable skills, most undeniable passions, and greatest sources of joy so you can identify your best path forward.`;
export const NEXT_TOKEN_2 = `Gain clarity on the next step you can take toward the life you really want to live.`;
